/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AppUnauthorizedImport } from './routes/_app/unauthorized'
import { Route as authSignUpSplatImport } from './routes/(auth)/sign-up/$'
import { Route as authLoginSplatImport } from './routes/(auth)/login/$'
import { Route as AppmultiLocationAdminRouteImport } from './routes/_app/(multi-location)/admin/route'
import { Route as AppsingleLocationMuseumIndexImport } from './routes/_app/(single-location)/museum/index'
import { Route as AppmultiLocationAdminIndexImport } from './routes/_app/(multi-location)/admin/index'
import { Route as AppsingleLocationMuseumMuseumIdRouteImport } from './routes/_app/(single-location)/museum/$museumId/route'
import { Route as AppsingleLocationMuseumMuseumIdIndexImport } from './routes/_app/(single-location)/museum/$museumId/index'
import { Route as AppmultiLocationAdminProductsIndexImport } from './routes/_app/(multi-location)/admin/products/index'
import { Route as AppmultiLocationAdminLocationsIndexImport } from './routes/_app/(multi-location)/admin/locations/index'
import { Route as AppmultiLocationAdminEmployeesIndexImport } from './routes/_app/(multi-location)/admin/employees/index'
import { Route as AppmultiLocationAdminCustomersIndexImport } from './routes/_app/(multi-location)/admin/customers/index'
import { Route as AppmultiLocationAdminBookingsIndexImport } from './routes/_app/(multi-location)/admin/bookings/index'
import { Route as AppsingleLocationMuseumMuseumIdReportIndexImport } from './routes/_app/(single-location)/museum/$museumId/report/index'
import { Route as AppsingleLocationMuseumMuseumIdProductsIndexImport } from './routes/_app/(single-location)/museum/$museumId/products/index'
import { Route as AppsingleLocationMuseumMuseumIdEmployeesIndexImport } from './routes/_app/(single-location)/museum/$museumId/employees/index'
import { Route as AppsingleLocationMuseumMuseumIdDepartamentsIndexImport } from './routes/_app/(single-location)/museum/$museumId/departaments/index'
import { Route as AppsingleLocationMuseumMuseumIdCustomersIndexImport } from './routes/_app/(single-location)/museum/$museumId/customers/index'
import { Route as AppsingleLocationMuseumMuseumIdCalendarIndexImport } from './routes/_app/(single-location)/museum/$museumId/calendar/index'
import { Route as AppsingleLocationMuseumMuseumIdBookingsIndexImport } from './routes/_app/(single-location)/museum/$museumId/bookings/index'
import { Route as AppmultiLocationAdminProductsCategoriesIndexImport } from './routes/_app/(multi-location)/admin/products/categories/index'
import { Route as AppmultiLocationAdminEmployeesEmployeeIdIndexImport } from './routes/_app/(multi-location)/admin/employees/$employeeId/index'
import { Route as AppmultiLocationAdminCustomersCustomerIdIndexImport } from './routes/_app/(multi-location)/admin/customers/$customerId/index'
import { Route as AppmultiLocationAdminBookingsBookingIdIndexImport } from './routes/_app/(multi-location)/admin/bookings/$bookingId/index'
import { Route as AppsingleLocationMuseumMuseumIdProductsCategoriesIndexImport } from './routes/_app/(single-location)/museum/$museumId/products/categories/index'
import { Route as AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexImport } from './routes/_app/(single-location)/museum/$museumId/employees/$employeeId/index'
import { Route as AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexImport } from './routes/_app/(single-location)/museum/$museumId/customers/$customerId/index'
import { Route as AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexImport } from './routes/_app/(single-location)/museum/$museumId/bookings/$bookingId/index'

// Create/Update Routes

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const AppUnauthorizedRoute = AppUnauthorizedImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AppRoute,
} as any)

const authSignUpSplatRoute = authSignUpSplatImport.update({
  id: '/(auth)/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRoute,
} as any)

const authLoginSplatRoute = authLoginSplatImport.update({
  id: '/(auth)/login/$',
  path: '/login/$',
  getParentRoute: () => rootRoute,
} as any)

const AppmultiLocationAdminRouteRoute = AppmultiLocationAdminRouteImport.update(
  {
    id: '/(multi-location)/admin',
    path: '/admin',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppsingleLocationMuseumIndexRoute =
  AppsingleLocationMuseumIndexImport.update({
    id: '/(single-location)/museum/',
    path: '/museum/',
    getParentRoute: () => AppRoute,
  } as any)

const AppmultiLocationAdminIndexRoute = AppmultiLocationAdminIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any,
)

const AppsingleLocationMuseumMuseumIdRouteRoute =
  AppsingleLocationMuseumMuseumIdRouteImport.update({
    id: '/(single-location)/museum/$museumId',
    path: '/museum/$museumId',
    getParentRoute: () => AppRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdIndexRoute =
  AppsingleLocationMuseumMuseumIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppmultiLocationAdminProductsIndexRoute =
  AppmultiLocationAdminProductsIndexImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminLocationsIndexRoute =
  AppmultiLocationAdminLocationsIndexImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminEmployeesIndexRoute =
  AppmultiLocationAdminEmployeesIndexImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminCustomersIndexRoute =
  AppmultiLocationAdminCustomersIndexImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminBookingsIndexRoute =
  AppmultiLocationAdminBookingsIndexImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdReportIndexRoute =
  AppsingleLocationMuseumMuseumIdReportIndexImport.update({
    id: '/report/',
    path: '/report/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdProductsIndexRoute =
  AppsingleLocationMuseumMuseumIdProductsIndexImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdEmployeesIndexRoute =
  AppsingleLocationMuseumMuseumIdEmployeesIndexImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute =
  AppsingleLocationMuseumMuseumIdDepartamentsIndexImport.update({
    id: '/departaments/',
    path: '/departaments/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdCustomersIndexRoute =
  AppsingleLocationMuseumMuseumIdCustomersIndexImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdCalendarIndexRoute =
  AppsingleLocationMuseumMuseumIdCalendarIndexImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdBookingsIndexRoute =
  AppsingleLocationMuseumMuseumIdBookingsIndexImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppmultiLocationAdminProductsCategoriesIndexRoute =
  AppmultiLocationAdminProductsCategoriesIndexImport.update({
    id: '/products/categories/',
    path: '/products/categories/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminEmployeesEmployeeIdIndexRoute =
  AppmultiLocationAdminEmployeesEmployeeIdIndexImport.update({
    id: '/employees/$employeeId/',
    path: '/employees/$employeeId/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminCustomersCustomerIdIndexRoute =
  AppmultiLocationAdminCustomersCustomerIdIndexImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppmultiLocationAdminBookingsBookingIdIndexRoute =
  AppmultiLocationAdminBookingsBookingIdIndexImport.update({
    id: '/bookings/$bookingId/',
    path: '/bookings/$bookingId/',
    getParentRoute: () => AppmultiLocationAdminRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute =
  AppsingleLocationMuseumMuseumIdProductsCategoriesIndexImport.update({
    id: '/products/categories/',
    path: '/products/categories/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute =
  AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexImport.update({
    id: '/employees/$employeeId/',
    path: '/employees/$employeeId/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute =
  AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

const AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute =
  AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexImport.update({
    id: '/bookings/$bookingId/',
    path: '/bookings/$bookingId/',
    getParentRoute: () => AppsingleLocationMuseumMuseumIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_app/unauthorized': {
      id: '/_app/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AppUnauthorizedImport
      parentRoute: typeof AppImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/(multi-location)/admin': {
      id: '/_app/(multi-location)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppmultiLocationAdminRouteImport
      parentRoute: typeof AppImport
    }
    '/(auth)/login/$': {
      id: '/(auth)/login/$'
      path: '/login/$'
      fullPath: '/login/$'
      preLoaderRoute: typeof authLoginSplatImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up/$': {
      id: '/(auth)/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof authSignUpSplatImport
      parentRoute: typeof rootRoute
    }
    '/_app/(single-location)/museum/$museumId': {
      id: '/_app/(single-location)/museum/$museumId'
      path: '/museum/$museumId'
      fullPath: '/museum/$museumId'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
      parentRoute: typeof AppImport
    }
    '/_app/(multi-location)/admin/': {
      id: '/_app/(multi-location)/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppmultiLocationAdminIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(single-location)/museum/': {
      id: '/_app/(single-location)/museum/'
      path: '/museum'
      fullPath: '/museum'
      preLoaderRoute: typeof AppsingleLocationMuseumIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/(multi-location)/admin/bookings/': {
      id: '/_app/(multi-location)/admin/bookings/'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AppmultiLocationAdminBookingsIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/customers/': {
      id: '/_app/(multi-location)/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AppmultiLocationAdminCustomersIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/employees/': {
      id: '/_app/(multi-location)/admin/employees/'
      path: '/employees'
      fullPath: '/admin/employees'
      preLoaderRoute: typeof AppmultiLocationAdminEmployeesIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/locations/': {
      id: '/_app/(multi-location)/admin/locations/'
      path: '/locations'
      fullPath: '/admin/locations'
      preLoaderRoute: typeof AppmultiLocationAdminLocationsIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/products/': {
      id: '/_app/(multi-location)/admin/products/'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AppmultiLocationAdminProductsIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(single-location)/museum/$museumId/': {
      id: '/_app/(single-location)/museum/$museumId/'
      path: '/'
      fullPath: '/museum/$museumId/'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(multi-location)/admin/bookings/$bookingId/': {
      id: '/_app/(multi-location)/admin/bookings/$bookingId/'
      path: '/bookings/$bookingId'
      fullPath: '/admin/bookings/$bookingId'
      preLoaderRoute: typeof AppmultiLocationAdminBookingsBookingIdIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/customers/$customerId/': {
      id: '/_app/(multi-location)/admin/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof AppmultiLocationAdminCustomersCustomerIdIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/employees/$employeeId/': {
      id: '/_app/(multi-location)/admin/employees/$employeeId/'
      path: '/employees/$employeeId'
      fullPath: '/admin/employees/$employeeId'
      preLoaderRoute: typeof AppmultiLocationAdminEmployeesEmployeeIdIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(multi-location)/admin/products/categories/': {
      id: '/_app/(multi-location)/admin/products/categories/'
      path: '/products/categories'
      fullPath: '/admin/products/categories'
      preLoaderRoute: typeof AppmultiLocationAdminProductsCategoriesIndexImport
      parentRoute: typeof AppmultiLocationAdminRouteImport
    }
    '/_app/(single-location)/museum/$museumId/bookings/': {
      id: '/_app/(single-location)/museum/$museumId/bookings/'
      path: '/bookings'
      fullPath: '/museum/$museumId/bookings'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdBookingsIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/calendar/': {
      id: '/_app/(single-location)/museum/$museumId/calendar/'
      path: '/calendar'
      fullPath: '/museum/$museumId/calendar'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdCalendarIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/customers/': {
      id: '/_app/(single-location)/museum/$museumId/customers/'
      path: '/customers'
      fullPath: '/museum/$museumId/customers'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdCustomersIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/departaments/': {
      id: '/_app/(single-location)/museum/$museumId/departaments/'
      path: '/departaments'
      fullPath: '/museum/$museumId/departaments'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdDepartamentsIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/employees/': {
      id: '/_app/(single-location)/museum/$museumId/employees/'
      path: '/employees'
      fullPath: '/museum/$museumId/employees'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdEmployeesIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/products/': {
      id: '/_app/(single-location)/museum/$museumId/products/'
      path: '/products'
      fullPath: '/museum/$museumId/products'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdProductsIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/report/': {
      id: '/_app/(single-location)/museum/$museumId/report/'
      path: '/report'
      fullPath: '/museum/$museumId/report'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdReportIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/bookings/$bookingId/': {
      id: '/_app/(single-location)/museum/$museumId/bookings/$bookingId/'
      path: '/bookings/$bookingId'
      fullPath: '/museum/$museumId/bookings/$bookingId'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/customers/$customerId/': {
      id: '/_app/(single-location)/museum/$museumId/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/museum/$museumId/customers/$customerId'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/employees/$employeeId/': {
      id: '/_app/(single-location)/museum/$museumId/employees/$employeeId/'
      path: '/employees/$employeeId'
      fullPath: '/museum/$museumId/employees/$employeeId'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
    '/_app/(single-location)/museum/$museumId/products/categories/': {
      id: '/_app/(single-location)/museum/$museumId/products/categories/'
      path: '/products/categories'
      fullPath: '/museum/$museumId/products/categories'
      preLoaderRoute: typeof AppsingleLocationMuseumMuseumIdProductsCategoriesIndexImport
      parentRoute: typeof AppsingleLocationMuseumMuseumIdRouteImport
    }
  }
}

// Create and export the route tree

interface AppmultiLocationAdminRouteRouteChildren {
  AppmultiLocationAdminIndexRoute: typeof AppmultiLocationAdminIndexRoute
  AppmultiLocationAdminBookingsIndexRoute: typeof AppmultiLocationAdminBookingsIndexRoute
  AppmultiLocationAdminCustomersIndexRoute: typeof AppmultiLocationAdminCustomersIndexRoute
  AppmultiLocationAdminEmployeesIndexRoute: typeof AppmultiLocationAdminEmployeesIndexRoute
  AppmultiLocationAdminLocationsIndexRoute: typeof AppmultiLocationAdminLocationsIndexRoute
  AppmultiLocationAdminProductsIndexRoute: typeof AppmultiLocationAdminProductsIndexRoute
  AppmultiLocationAdminBookingsBookingIdIndexRoute: typeof AppmultiLocationAdminBookingsBookingIdIndexRoute
  AppmultiLocationAdminCustomersCustomerIdIndexRoute: typeof AppmultiLocationAdminCustomersCustomerIdIndexRoute
  AppmultiLocationAdminEmployeesEmployeeIdIndexRoute: typeof AppmultiLocationAdminEmployeesEmployeeIdIndexRoute
  AppmultiLocationAdminProductsCategoriesIndexRoute: typeof AppmultiLocationAdminProductsCategoriesIndexRoute
}

const AppmultiLocationAdminRouteRouteChildren: AppmultiLocationAdminRouteRouteChildren =
  {
    AppmultiLocationAdminIndexRoute: AppmultiLocationAdminIndexRoute,
    AppmultiLocationAdminBookingsIndexRoute:
      AppmultiLocationAdminBookingsIndexRoute,
    AppmultiLocationAdminCustomersIndexRoute:
      AppmultiLocationAdminCustomersIndexRoute,
    AppmultiLocationAdminEmployeesIndexRoute:
      AppmultiLocationAdminEmployeesIndexRoute,
    AppmultiLocationAdminLocationsIndexRoute:
      AppmultiLocationAdminLocationsIndexRoute,
    AppmultiLocationAdminProductsIndexRoute:
      AppmultiLocationAdminProductsIndexRoute,
    AppmultiLocationAdminBookingsBookingIdIndexRoute:
      AppmultiLocationAdminBookingsBookingIdIndexRoute,
    AppmultiLocationAdminCustomersCustomerIdIndexRoute:
      AppmultiLocationAdminCustomersCustomerIdIndexRoute,
    AppmultiLocationAdminEmployeesEmployeeIdIndexRoute:
      AppmultiLocationAdminEmployeesEmployeeIdIndexRoute,
    AppmultiLocationAdminProductsCategoriesIndexRoute:
      AppmultiLocationAdminProductsCategoriesIndexRoute,
  }

const AppmultiLocationAdminRouteRouteWithChildren =
  AppmultiLocationAdminRouteRoute._addFileChildren(
    AppmultiLocationAdminRouteRouteChildren,
  )

interface AppsingleLocationMuseumMuseumIdRouteRouteChildren {
  AppsingleLocationMuseumMuseumIdIndexRoute: typeof AppsingleLocationMuseumMuseumIdIndexRoute
  AppsingleLocationMuseumMuseumIdBookingsIndexRoute: typeof AppsingleLocationMuseumMuseumIdBookingsIndexRoute
  AppsingleLocationMuseumMuseumIdCalendarIndexRoute: typeof AppsingleLocationMuseumMuseumIdCalendarIndexRoute
  AppsingleLocationMuseumMuseumIdCustomersIndexRoute: typeof AppsingleLocationMuseumMuseumIdCustomersIndexRoute
  AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute: typeof AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute
  AppsingleLocationMuseumMuseumIdEmployeesIndexRoute: typeof AppsingleLocationMuseumMuseumIdEmployeesIndexRoute
  AppsingleLocationMuseumMuseumIdProductsIndexRoute: typeof AppsingleLocationMuseumMuseumIdProductsIndexRoute
  AppsingleLocationMuseumMuseumIdReportIndexRoute: typeof AppsingleLocationMuseumMuseumIdReportIndexRoute
  AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute: typeof AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute
  AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute: typeof AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute
  AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute: typeof AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute
  AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute: typeof AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute
}

const AppsingleLocationMuseumMuseumIdRouteRouteChildren: AppsingleLocationMuseumMuseumIdRouteRouteChildren =
  {
    AppsingleLocationMuseumMuseumIdIndexRoute:
      AppsingleLocationMuseumMuseumIdIndexRoute,
    AppsingleLocationMuseumMuseumIdBookingsIndexRoute:
      AppsingleLocationMuseumMuseumIdBookingsIndexRoute,
    AppsingleLocationMuseumMuseumIdCalendarIndexRoute:
      AppsingleLocationMuseumMuseumIdCalendarIndexRoute,
    AppsingleLocationMuseumMuseumIdCustomersIndexRoute:
      AppsingleLocationMuseumMuseumIdCustomersIndexRoute,
    AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute:
      AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute,
    AppsingleLocationMuseumMuseumIdEmployeesIndexRoute:
      AppsingleLocationMuseumMuseumIdEmployeesIndexRoute,
    AppsingleLocationMuseumMuseumIdProductsIndexRoute:
      AppsingleLocationMuseumMuseumIdProductsIndexRoute,
    AppsingleLocationMuseumMuseumIdReportIndexRoute:
      AppsingleLocationMuseumMuseumIdReportIndexRoute,
    AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute:
      AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute,
    AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute:
      AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute,
    AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute:
      AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute,
    AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute:
      AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute,
  }

const AppsingleLocationMuseumMuseumIdRouteRouteWithChildren =
  AppsingleLocationMuseumMuseumIdRouteRoute._addFileChildren(
    AppsingleLocationMuseumMuseumIdRouteRouteChildren,
  )

interface AppRouteChildren {
  AppUnauthorizedRoute: typeof AppUnauthorizedRoute
  AppIndexRoute: typeof AppIndexRoute
  AppmultiLocationAdminRouteRoute: typeof AppmultiLocationAdminRouteRouteWithChildren
  AppsingleLocationMuseumMuseumIdRouteRoute: typeof AppsingleLocationMuseumMuseumIdRouteRouteWithChildren
  AppsingleLocationMuseumIndexRoute: typeof AppsingleLocationMuseumIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppUnauthorizedRoute: AppUnauthorizedRoute,
  AppIndexRoute: AppIndexRoute,
  AppmultiLocationAdminRouteRoute: AppmultiLocationAdminRouteRouteWithChildren,
  AppsingleLocationMuseumMuseumIdRouteRoute:
    AppsingleLocationMuseumMuseumIdRouteRouteWithChildren,
  AppsingleLocationMuseumIndexRoute: AppsingleLocationMuseumIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AppRouteWithChildren
  '/unauthorized': typeof AppUnauthorizedRoute
  '/': typeof AppIndexRoute
  '/admin': typeof AppmultiLocationAdminRouteRouteWithChildren
  '/login/$': typeof authLoginSplatRoute
  '/sign-up/$': typeof authSignUpSplatRoute
  '/museum/$museumId': typeof AppsingleLocationMuseumMuseumIdRouteRouteWithChildren
  '/admin/': typeof AppmultiLocationAdminIndexRoute
  '/museum': typeof AppsingleLocationMuseumIndexRoute
  '/admin/bookings': typeof AppmultiLocationAdminBookingsIndexRoute
  '/admin/customers': typeof AppmultiLocationAdminCustomersIndexRoute
  '/admin/employees': typeof AppmultiLocationAdminEmployeesIndexRoute
  '/admin/locations': typeof AppmultiLocationAdminLocationsIndexRoute
  '/admin/products': typeof AppmultiLocationAdminProductsIndexRoute
  '/museum/$museumId/': typeof AppsingleLocationMuseumMuseumIdIndexRoute
  '/admin/bookings/$bookingId': typeof AppmultiLocationAdminBookingsBookingIdIndexRoute
  '/admin/customers/$customerId': typeof AppmultiLocationAdminCustomersCustomerIdIndexRoute
  '/admin/employees/$employeeId': typeof AppmultiLocationAdminEmployeesEmployeeIdIndexRoute
  '/admin/products/categories': typeof AppmultiLocationAdminProductsCategoriesIndexRoute
  '/museum/$museumId/bookings': typeof AppsingleLocationMuseumMuseumIdBookingsIndexRoute
  '/museum/$museumId/calendar': typeof AppsingleLocationMuseumMuseumIdCalendarIndexRoute
  '/museum/$museumId/customers': typeof AppsingleLocationMuseumMuseumIdCustomersIndexRoute
  '/museum/$museumId/departaments': typeof AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute
  '/museum/$museumId/employees': typeof AppsingleLocationMuseumMuseumIdEmployeesIndexRoute
  '/museum/$museumId/products': typeof AppsingleLocationMuseumMuseumIdProductsIndexRoute
  '/museum/$museumId/report': typeof AppsingleLocationMuseumMuseumIdReportIndexRoute
  '/museum/$museumId/bookings/$bookingId': typeof AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute
  '/museum/$museumId/customers/$customerId': typeof AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute
  '/museum/$museumId/employees/$employeeId': typeof AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute
  '/museum/$museumId/products/categories': typeof AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute
}

export interface FileRoutesByTo {
  '/unauthorized': typeof AppUnauthorizedRoute
  '/': typeof AppIndexRoute
  '/login/$': typeof authLoginSplatRoute
  '/sign-up/$': typeof authSignUpSplatRoute
  '/admin': typeof AppmultiLocationAdminIndexRoute
  '/museum': typeof AppsingleLocationMuseumIndexRoute
  '/admin/bookings': typeof AppmultiLocationAdminBookingsIndexRoute
  '/admin/customers': typeof AppmultiLocationAdminCustomersIndexRoute
  '/admin/employees': typeof AppmultiLocationAdminEmployeesIndexRoute
  '/admin/locations': typeof AppmultiLocationAdminLocationsIndexRoute
  '/admin/products': typeof AppmultiLocationAdminProductsIndexRoute
  '/museum/$museumId': typeof AppsingleLocationMuseumMuseumIdIndexRoute
  '/admin/bookings/$bookingId': typeof AppmultiLocationAdminBookingsBookingIdIndexRoute
  '/admin/customers/$customerId': typeof AppmultiLocationAdminCustomersCustomerIdIndexRoute
  '/admin/employees/$employeeId': typeof AppmultiLocationAdminEmployeesEmployeeIdIndexRoute
  '/admin/products/categories': typeof AppmultiLocationAdminProductsCategoriesIndexRoute
  '/museum/$museumId/bookings': typeof AppsingleLocationMuseumMuseumIdBookingsIndexRoute
  '/museum/$museumId/calendar': typeof AppsingleLocationMuseumMuseumIdCalendarIndexRoute
  '/museum/$museumId/customers': typeof AppsingleLocationMuseumMuseumIdCustomersIndexRoute
  '/museum/$museumId/departaments': typeof AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute
  '/museum/$museumId/employees': typeof AppsingleLocationMuseumMuseumIdEmployeesIndexRoute
  '/museum/$museumId/products': typeof AppsingleLocationMuseumMuseumIdProductsIndexRoute
  '/museum/$museumId/report': typeof AppsingleLocationMuseumMuseumIdReportIndexRoute
  '/museum/$museumId/bookings/$bookingId': typeof AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute
  '/museum/$museumId/customers/$customerId': typeof AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute
  '/museum/$museumId/employees/$employeeId': typeof AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute
  '/museum/$museumId/products/categories': typeof AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/unauthorized': typeof AppUnauthorizedRoute
  '/_app/': typeof AppIndexRoute
  '/_app/(multi-location)/admin': typeof AppmultiLocationAdminRouteRouteWithChildren
  '/(auth)/login/$': typeof authLoginSplatRoute
  '/(auth)/sign-up/$': typeof authSignUpSplatRoute
  '/_app/(single-location)/museum/$museumId': typeof AppsingleLocationMuseumMuseumIdRouteRouteWithChildren
  '/_app/(multi-location)/admin/': typeof AppmultiLocationAdminIndexRoute
  '/_app/(single-location)/museum/': typeof AppsingleLocationMuseumIndexRoute
  '/_app/(multi-location)/admin/bookings/': typeof AppmultiLocationAdminBookingsIndexRoute
  '/_app/(multi-location)/admin/customers/': typeof AppmultiLocationAdminCustomersIndexRoute
  '/_app/(multi-location)/admin/employees/': typeof AppmultiLocationAdminEmployeesIndexRoute
  '/_app/(multi-location)/admin/locations/': typeof AppmultiLocationAdminLocationsIndexRoute
  '/_app/(multi-location)/admin/products/': typeof AppmultiLocationAdminProductsIndexRoute
  '/_app/(single-location)/museum/$museumId/': typeof AppsingleLocationMuseumMuseumIdIndexRoute
  '/_app/(multi-location)/admin/bookings/$bookingId/': typeof AppmultiLocationAdminBookingsBookingIdIndexRoute
  '/_app/(multi-location)/admin/customers/$customerId/': typeof AppmultiLocationAdminCustomersCustomerIdIndexRoute
  '/_app/(multi-location)/admin/employees/$employeeId/': typeof AppmultiLocationAdminEmployeesEmployeeIdIndexRoute
  '/_app/(multi-location)/admin/products/categories/': typeof AppmultiLocationAdminProductsCategoriesIndexRoute
  '/_app/(single-location)/museum/$museumId/bookings/': typeof AppsingleLocationMuseumMuseumIdBookingsIndexRoute
  '/_app/(single-location)/museum/$museumId/calendar/': typeof AppsingleLocationMuseumMuseumIdCalendarIndexRoute
  '/_app/(single-location)/museum/$museumId/customers/': typeof AppsingleLocationMuseumMuseumIdCustomersIndexRoute
  '/_app/(single-location)/museum/$museumId/departaments/': typeof AppsingleLocationMuseumMuseumIdDepartamentsIndexRoute
  '/_app/(single-location)/museum/$museumId/employees/': typeof AppsingleLocationMuseumMuseumIdEmployeesIndexRoute
  '/_app/(single-location)/museum/$museumId/products/': typeof AppsingleLocationMuseumMuseumIdProductsIndexRoute
  '/_app/(single-location)/museum/$museumId/report/': typeof AppsingleLocationMuseumMuseumIdReportIndexRoute
  '/_app/(single-location)/museum/$museumId/bookings/$bookingId/': typeof AppsingleLocationMuseumMuseumIdBookingsBookingIdIndexRoute
  '/_app/(single-location)/museum/$museumId/customers/$customerId/': typeof AppsingleLocationMuseumMuseumIdCustomersCustomerIdIndexRoute
  '/_app/(single-location)/museum/$museumId/employees/$employeeId/': typeof AppsingleLocationMuseumMuseumIdEmployeesEmployeeIdIndexRoute
  '/_app/(single-location)/museum/$museumId/products/categories/': typeof AppsingleLocationMuseumMuseumIdProductsCategoriesIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/unauthorized'
    | '/'
    | '/admin'
    | '/login/$'
    | '/sign-up/$'
    | '/museum/$museumId'
    | '/admin/'
    | '/museum'
    | '/admin/bookings'
    | '/admin/customers'
    | '/admin/employees'
    | '/admin/locations'
    | '/admin/products'
    | '/museum/$museumId/'
    | '/admin/bookings/$bookingId'
    | '/admin/customers/$customerId'
    | '/admin/employees/$employeeId'
    | '/admin/products/categories'
    | '/museum/$museumId/bookings'
    | '/museum/$museumId/calendar'
    | '/museum/$museumId/customers'
    | '/museum/$museumId/departaments'
    | '/museum/$museumId/employees'
    | '/museum/$museumId/products'
    | '/museum/$museumId/report'
    | '/museum/$museumId/bookings/$bookingId'
    | '/museum/$museumId/customers/$customerId'
    | '/museum/$museumId/employees/$employeeId'
    | '/museum/$museumId/products/categories'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/unauthorized'
    | '/'
    | '/login/$'
    | '/sign-up/$'
    | '/admin'
    | '/museum'
    | '/admin/bookings'
    | '/admin/customers'
    | '/admin/employees'
    | '/admin/locations'
    | '/admin/products'
    | '/museum/$museumId'
    | '/admin/bookings/$bookingId'
    | '/admin/customers/$customerId'
    | '/admin/employees/$employeeId'
    | '/admin/products/categories'
    | '/museum/$museumId/bookings'
    | '/museum/$museumId/calendar'
    | '/museum/$museumId/customers'
    | '/museum/$museumId/departaments'
    | '/museum/$museumId/employees'
    | '/museum/$museumId/products'
    | '/museum/$museumId/report'
    | '/museum/$museumId/bookings/$bookingId'
    | '/museum/$museumId/customers/$customerId'
    | '/museum/$museumId/employees/$employeeId'
    | '/museum/$museumId/products/categories'
  id:
    | '__root__'
    | '/_app'
    | '/_app/unauthorized'
    | '/_app/'
    | '/_app/(multi-location)/admin'
    | '/(auth)/login/$'
    | '/(auth)/sign-up/$'
    | '/_app/(single-location)/museum/$museumId'
    | '/_app/(multi-location)/admin/'
    | '/_app/(single-location)/museum/'
    | '/_app/(multi-location)/admin/bookings/'
    | '/_app/(multi-location)/admin/customers/'
    | '/_app/(multi-location)/admin/employees/'
    | '/_app/(multi-location)/admin/locations/'
    | '/_app/(multi-location)/admin/products/'
    | '/_app/(single-location)/museum/$museumId/'
    | '/_app/(multi-location)/admin/bookings/$bookingId/'
    | '/_app/(multi-location)/admin/customers/$customerId/'
    | '/_app/(multi-location)/admin/employees/$employeeId/'
    | '/_app/(multi-location)/admin/products/categories/'
    | '/_app/(single-location)/museum/$museumId/bookings/'
    | '/_app/(single-location)/museum/$museumId/calendar/'
    | '/_app/(single-location)/museum/$museumId/customers/'
    | '/_app/(single-location)/museum/$museumId/departaments/'
    | '/_app/(single-location)/museum/$museumId/employees/'
    | '/_app/(single-location)/museum/$museumId/products/'
    | '/_app/(single-location)/museum/$museumId/report/'
    | '/_app/(single-location)/museum/$museumId/bookings/$bookingId/'
    | '/_app/(single-location)/museum/$museumId/customers/$customerId/'
    | '/_app/(single-location)/museum/$museumId/employees/$employeeId/'
    | '/_app/(single-location)/museum/$museumId/products/categories/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  authLoginSplatRoute: typeof authLoginSplatRoute
  authSignUpSplatRoute: typeof authSignUpSplatRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  authLoginSplatRoute: authLoginSplatRoute,
  authSignUpSplatRoute: authSignUpSplatRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/(auth)/login/$",
        "/(auth)/sign-up/$"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/unauthorized",
        "/_app/",
        "/_app/(multi-location)/admin",
        "/_app/(single-location)/museum/$museumId",
        "/_app/(single-location)/museum/"
      ]
    },
    "/_app/unauthorized": {
      "filePath": "_app/unauthorized.tsx",
      "parent": "/_app"
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/_app/(multi-location)/admin": {
      "filePath": "_app/(multi-location)/admin/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/(multi-location)/admin/",
        "/_app/(multi-location)/admin/bookings/",
        "/_app/(multi-location)/admin/customers/",
        "/_app/(multi-location)/admin/employees/",
        "/_app/(multi-location)/admin/locations/",
        "/_app/(multi-location)/admin/products/",
        "/_app/(multi-location)/admin/bookings/$bookingId/",
        "/_app/(multi-location)/admin/customers/$customerId/",
        "/_app/(multi-location)/admin/employees/$employeeId/",
        "/_app/(multi-location)/admin/products/categories/"
      ]
    },
    "/(auth)/login/$": {
      "filePath": "(auth)/login/$.tsx"
    },
    "/(auth)/sign-up/$": {
      "filePath": "(auth)/sign-up/$.tsx"
    },
    "/_app/(single-location)/museum/$museumId": {
      "filePath": "_app/(single-location)/museum/$museumId/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/(single-location)/museum/$museumId/",
        "/_app/(single-location)/museum/$museumId/bookings/",
        "/_app/(single-location)/museum/$museumId/calendar/",
        "/_app/(single-location)/museum/$museumId/customers/",
        "/_app/(single-location)/museum/$museumId/departaments/",
        "/_app/(single-location)/museum/$museumId/employees/",
        "/_app/(single-location)/museum/$museumId/products/",
        "/_app/(single-location)/museum/$museumId/report/",
        "/_app/(single-location)/museum/$museumId/bookings/$bookingId/",
        "/_app/(single-location)/museum/$museumId/customers/$customerId/",
        "/_app/(single-location)/museum/$museumId/employees/$employeeId/",
        "/_app/(single-location)/museum/$museumId/products/categories/"
      ]
    },
    "/_app/(multi-location)/admin/": {
      "filePath": "_app/(multi-location)/admin/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(single-location)/museum/": {
      "filePath": "_app/(single-location)/museum/index.tsx",
      "parent": "/_app"
    },
    "/_app/(multi-location)/admin/bookings/": {
      "filePath": "_app/(multi-location)/admin/bookings/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/customers/": {
      "filePath": "_app/(multi-location)/admin/customers/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/employees/": {
      "filePath": "_app/(multi-location)/admin/employees/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/locations/": {
      "filePath": "_app/(multi-location)/admin/locations/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/products/": {
      "filePath": "_app/(multi-location)/admin/products/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(single-location)/museum/$museumId/": {
      "filePath": "_app/(single-location)/museum/$museumId/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(multi-location)/admin/bookings/$bookingId/": {
      "filePath": "_app/(multi-location)/admin/bookings/$bookingId/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/customers/$customerId/": {
      "filePath": "_app/(multi-location)/admin/customers/$customerId/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/employees/$employeeId/": {
      "filePath": "_app/(multi-location)/admin/employees/$employeeId/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(multi-location)/admin/products/categories/": {
      "filePath": "_app/(multi-location)/admin/products/categories/index.tsx",
      "parent": "/_app/(multi-location)/admin"
    },
    "/_app/(single-location)/museum/$museumId/bookings/": {
      "filePath": "_app/(single-location)/museum/$museumId/bookings/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/calendar/": {
      "filePath": "_app/(single-location)/museum/$museumId/calendar/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/customers/": {
      "filePath": "_app/(single-location)/museum/$museumId/customers/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/departaments/": {
      "filePath": "_app/(single-location)/museum/$museumId/departaments/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/employees/": {
      "filePath": "_app/(single-location)/museum/$museumId/employees/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/products/": {
      "filePath": "_app/(single-location)/museum/$museumId/products/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/report/": {
      "filePath": "_app/(single-location)/museum/$museumId/report/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/bookings/$bookingId/": {
      "filePath": "_app/(single-location)/museum/$museumId/bookings/$bookingId/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/customers/$customerId/": {
      "filePath": "_app/(single-location)/museum/$museumId/customers/$customerId/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/employees/$employeeId/": {
      "filePath": "_app/(single-location)/museum/$museumId/employees/$employeeId/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    },
    "/_app/(single-location)/museum/$museumId/products/categories/": {
      "filePath": "_app/(single-location)/museum/$museumId/products/categories/index.tsx",
      "parent": "/_app/(single-location)/museum/$museumId"
    }
  }
}
ROUTE_MANIFEST_END */
